// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wbs-category {
  font-family: "Gotham-Book";
  font-size: 0.8em;
  font-weight: 500;
  color: var(--ion-color-primary);
  margin: 0.5em !important;
  font-weight: bold;
}

.wbs-display {
  font-family: "Gotham-Book";
  font-size: 0.75em;
  font-weight: 500;
  color: var(--ion-color-primary);
  margin: 0.5em !important;
}

.wbs-name {
  font-family: "Gotham-Book";
  font-size: 1em;
  font-weight: bold;
  color: var(--ion-color-dark);
  margin: 0.5em !important;
}

.border {
  border-width: 1px;
  border-color: #dbdcdd;
  border-style: none none solid none;
  margin: 5px 0px;
}

.listGrid {
  border-width: 1px;
  border-color: #dbdcdd;
  border-style: none none solid none;
  margin: 12px;
  display: block;
}

.note-count {
  position: relative;
  width: fit-content;
  padding: 2px 10px;
  align-items: center;
  display: flex;
}

.spacing {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.hierarchyRow {
  display: inline-flex;
  width: 100%;
  min-height: 4em;
}

.hierarchyRow-nested {
  min-height: 4em;
  display: block;
  background-color: #F5F5F6;
  padding-left: 5px;
  width: 100%;
}

@media (max-width: 400px) {
  .hierarchyCol-content {
    width: 70% !important;
  }
  .hierarchyRow-icons {
    width: 30% !important;
  }
}
.hierarchyCol-content {
  width: 100%;
  display: inline-flex;
}

.hierarchyRow-icons {
  width: 20%;
  min-width: 100px;
  max-width: 200px;
  display: inline-flex;
  position: absolute;
  right: 8px;
}

.hierarchyRow-icon {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.hierarchyRow-icon ion-button {
  height: 2vh;
}

.msgContainer {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
}

.deleted-label {
  text-align: center;
  font-size: 0.65em;
  width: 12em;
  color: #ff0000;
  border: 1px solid #ff0000;
  border-radius: 15px;
  padding: 4px;
  font-weight: bold;
  margin-left: 0.5em !important;
}

@media only screen and (max-width: 600px) {
  .wbs-name {
    font-size: 2.5vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/hierarchylist-withnotes/hierarchylist-withnotes.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AAEA;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,wBAAA;AACF;;AAGA;EACE,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,qBAAA;EACA,kCAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,qBAAA;EACA,kCAAA;EACA,YAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE;IACE,qBAAA;EAAF;EAGA;IACE,qBAAA;EADF;AACF;AAIA;EACE,WAAA;EACA,oBAAA;AAFF;;AAKA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AAFF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AAJF;AAME;EACE,WAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AALF;;AAQA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;AALF;;AAQA;EACE;IACE,gBAAA;EALF;AACF","sourcesContent":[".wbs-category {\n  font-family: \"Gotham-Book\";\n  font-size: 0.8em;\n  font-weight: 500;\n  color: var(--ion-color-primary);\n  margin: 0.5em !important;\n  font-weight: bold;\n}\n\n.wbs-display {\n  font-family: \"Gotham-Book\";\n  font-size: 0.75em;\n  font-weight: 500;\n  color: var(--ion-color-primary);\n  margin: 0.5em !important;\n}\n\n\n.wbs-name {\n  font-family: \"Gotham-Book\";\n  font-size: 1em;\n  font-weight: bold;\n  color: var(--ion-color-dark);\n  margin: 0.5em !important;\n}\n\n.border {\n  border-width: 1px;\n  border-color: #dbdcdd;\n  border-style: none none solid none;\n  margin: 5px 0px;\n}\n\n.listGrid {\n  border-width: 1px;\n  border-color: #dbdcdd;\n  border-style: none none solid none;\n  margin: 12px;\n  display: block;\n}\n\n.note-count {\n  position: relative;\n  width: fit-content;\n  padding: 2px 10px;\n  align-items: center;\n  display: flex;\n}\n\n.spacing {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\n.hierarchyRow {\n  display: inline-flex;\n  width: 100%;\n  min-height: 4em;\n}\n\n.hierarchyRow-nested {\n  min-height: 4em;\n  display: block;\n  background-color: #F5F5F6;\n  padding-left: 5px;\n  width: 100%\n}\n\n@media (max-width: 400px) {\n  .hierarchyCol-content {\n    width: 70% !important;\n  }\n\n  .hierarchyRow-icons {\n    width: 30% !important;\n  }\n}\n\n.hierarchyCol-content {\n  width: 100%;\n  display: inline-flex;\n}\n\n.hierarchyRow-icons {\n  width: 20%;\n  min-width: 100px;\n  max-width: 200px;\n  display: inline-flex;\n  position: absolute;\n  right: 8px;\n}\n\n.hierarchyRow-msg {}\n\n.hierarchyRow-icon {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  ion-button {\n    height: 2vh;\n  }\n}\n\n.msgContainer {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.deleted-label {\n  text-align: center;\n  font-size: 0.65em;\n  width: 12em;\n  color: #ff0000;\n  border: 1px solid #ff0000;\n  border-radius: 15px;\n  padding: 4px;\n  font-weight: bold;\n  margin-left: 0.5em !important;\n}\n\n@media only screen and (max-width: 600px) {\n  .wbs-name {\n    font-size: 2.5vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
